import React from "react";
import s from "./PropertyListHeader.module.scss";
import {IPropertyWrapper} from "./DocumentationTypes";

export interface IPropertyListHeader {
  properties?: IPropertyWrapper[];
}

export function PropertyListHeader({ properties }: IPropertyListHeader) {
  return <div className={s.container}>
    <h1 className={s.propertiesLabel}>Properties</h1>
    <div className={s.propertiesListContainer}>
      <div className={s.requiredDescriptionContainer}>
        <span className={s.requiredIndicator}>*</span>
        Denotes required property.
      </div>
      {
        !properties
          ? null
          : <div className={s.propertiesList}>
            {
              properties.map((property, index) => {
                return <div
                  key={index}
                  className={s.propertyName}
                  onClick={() => {
                    const anchor = document.getElementById(`property_${property.name}`);
                    if (anchor) {
                      anchor.scrollIntoView({ behavior: "smooth" });
                    }
                  }}>
                  {property.name}
                  { property.isRequired ? <span className={s.requiredIndicator}> *</span> : null }
                </div>
              })
            }
          </div>
      }
    </div>
    <hr className={s.divider} />
  </div>
};